import * as XLSX from 'xlsx';
import { Button, Col, Container, Dropdown, Form, NavDropdown, Row } from "react-bootstrap";
import styles from './integration.module.scss'
import { api } from "../../../Utils/API";
import { INTEGRATION_LISTING, DOWNLOAD_CONNECTWISE_USER_GUIDE, XERO_DOWNLOAD_REPORT, GET_SERVICES_ALL } from '../../../Utils/GlobalConstants';
import React, { useState, useEffect } from 'react'
import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';
import { XLg } from 'react-bootstrap-icons';
import { useNavigate } from "react-router-dom";
import AccessDenied from "../../../GlobalComponents/EmptyStates/AccessDenied";
import Toast from "../../../GlobalComponents/Toast";
import { TOAST_ERROR_ICON_COLOR } from "../../../Utils/ColorsConfiguration";
import { GenericDownloadEmptyToast } from "../../../Utils/StaticMessages/ToastMessages";
import { sanitizeHTML } from '../../../Utils/Sanitize';

const Integrations = ({ toggleDrawer, setSelectService, setSelectCategory, setIntegrationContactUsFormFlag, integrationContactUsFormFlag, setComingFromIntegration, Logout }) => {

    const navigate = useNavigate();
    const [isreadOnly, setIsreadOnly] = useState(localStorage.getItem("read_array") && localStorage.getItem("read_array").includes("Integration") ? true : false);       // for read only mode
    const [isDisabled, setIsDisabled] = useState(localStorage.getItem("disabled_array") && localStorage.getItem("disabled_array").includes("Integration") ? true : false); // for disabled mode
    const [integrationData, setIntegrationData] = useState(null);      // storing integration data
    const [modalOpen, setModalOpen] = useState(false);                 // for opening popup which is having Connectwise Details
    const defaultServiceName = "Connectwise";
    const defaultCategoryName = "Cloud Technical Support";
    const [serviceData, setServiceData] = useState(null);                             // data in service dropdown

    // Use State for Toasts
    const [toastError, setToastError] = useState(false);                                // toast message displaying error message 
    const [toastMessage, setToastMessage] = useState("");                               // toast message usestate

    // Header Authorization for General API's
    const config = {
        headers: {
            "Authorization": `${localStorage.getItem("token_type")} ${localStorage.getItem("access_token")}`,
        },
    };

    // Function to call integrations api
    async function GetIntegrationListing() {
        await api.get(INTEGRATION_LISTING, config)
            .then(resp => {
                // console.log("Integration Listing :", resp.data.content);
                setIntegrationData(resp.data.content);
            })
            .catch(error => {
                if (error?.status == 401 || error?.response?.status == 401) {
                    Logout();
                }
                else {
                }
            });
    };

    // Function to call all dropdown values in Service Section in Filter Box
    async function GetServices() {
        await api.get(GET_SERVICES_ALL, config)
            .then(resp => {
                setServiceData(resp.data);
            })
            .catch(error => {
                // console.log(error)
                if (error?.status == 401 || error?.response?.status == 401) {
                    // console.log("Error 401");
                    Logout();
                }
                else {
                    // console.log(error);
                }
            });
    };

    // Header Authorization for Download PDF API having response type as blob
    const configBlob = {
        headers: {
            "Authorization": `${localStorage.getItem("token_type")} ${localStorage.getItem("access_token")}`,
        },
        responseType: 'blob',
    };

    // Download File using Js blobs
    const downloadFile = ({ data, fileName, fileType }) => {
        const blob = new Blob([data], { type: fileType })
        const a = document.createElement('a')
        a.download = fileName
        if (fileType === "application/pdf") {
            a.href = window.URL.createObjectURL(data)
        }
        else {
            a.href = window.URL.createObjectURL(blob)
        }
        const clickEvt = new MouseEvent('click', {
            view: window,
            bubbles: true,
            cancelable: true,
        })
        a.dispatchEvent(clickEvt)
        a.remove()
    }

    // Download PDF and CSV File 
    async function DownloadAction(url, name, fileType, integrationCode) {
        let configuration;
        if (fileType === "pdf") {
            configuration = configBlob;
        }
        else {
            configuration = config;
        }
        await api.get(`${url}?integrationCode=${integrationCode}`, configuration)
            .then(resp => {
                // handle success
                if (resp.status === 204) {
                    setToastMessage(GenericDownloadEmptyToast);
                    setToastError(true);
                    setTimeout(() => {
                        setToastError(false);
                    }, 2000);
                }
                else {
                    downloadFile({
                        data: (resp.data),
                        fileName: name,
                        fileType: `application/${fileType}`,
                    });
                }
            })
            .catch(error => {
                if (error?.status == 401 || error?.response?.status == 401) {
                    Logout();
                }
                else {
                    setToastMessage(GenericDownloadEmptyToast);
                    setToastError(true);
                    setTimeout(() => {
                        setToastError(false);
                    }, 2000);
                }
            });
    };

        // Download PDF and CSV File for Xero
        async function DownloadReport(url, name, fileType,reportType,integrationCode) {
            let configuration;
            if (fileType === "csv") {
                configuration = configBlob;
            }
            else {
                configuration = config;
            }
            await api.get(`${url}${integrationCode}/${reportType}`, configuration)
                .then(resp => {
                    // handle success
                    if (resp.status === 204) {
                        setToastMessage(GenericDownloadEmptyToast);
                        setToastError(true);
                        setTimeout(() => {
                            setToastError(false);
                        }, 2000);
                    }
                    else if (fileType === "xlsx") {
                        // Backend returns CSV text — convert to a real XLSX workbook on the frontend.
                        // Strip ALL \r characters first to neutralise Windows/old-Mac line endings
                        // before any further processing (prevents _x000d_ artifacts in SheetJS output).
                        const rawText = typeof resp.data === 'string' ? resp.data : String(resp.data);
                        const csvText = rawText.replace(/\r/g, '');

                        // Parse CSV into rows (handles basic quoted fields)
                        const parseCSVRow = (line) => {
                            const cells = [];
                            let inQuotes = false;
                            let cell = '';
                            for (let i = 0; i < line.length; i++) {
                                if (line[i] === '"') { inQuotes = !inQuotes; }
                                else if (line[i] === ',' && !inQuotes) { cells.push(cell); cell = ''; }
                                else { cell += line[i]; }
                            }
                            cells.push(cell);
                            return cells;
                        };

                        const rows = csvText.trim().split('\n').map(parseCSVRow);
                        if (rows.length === 0) return;

                        // Identify columns whose header contains "Date" (case-insensitive)
                        const headers = rows[0];
                        const dateColIndices = new Set(
                            headers.reduce((acc, h, i) => {
                                if (h.toLowerCase().includes('date')) acc.push(i);
                                return acc;
                            }, [])
                        );

                        // Build array-of-arrays; wrap date column cells as explicit strings
                        // so SheetJS never converts YYYY-MM-DD to an Excel serial number.
                        const aoaData = rows.map((row, rowIdx) =>
                            row.map((cellVal, colIdx) => {
                                if (rowIdx > 0 && dateColIndices.has(colIdx)) {
                                    return { v: cellVal, t: 's' }; // force string type
                                }
                                return cellVal;
                            })
                        );

                        const worksheet = XLSX.utils.aoa_to_sheet(aoaData);
                        const workbook = XLSX.utils.book_new();
                        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
                        const xlsxBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
                        const blob = new Blob([xlsxBuffer], {
                            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                        });
                        const a = document.createElement('a');
                        a.download = name;
                        a.href = window.URL.createObjectURL(blob);
                        const clickEvt = new MouseEvent('click', { view: window, bubbles: true, cancelable: true });
                        a.dispatchEvent(clickEvt);
                        a.remove();
                    }
                    else {
                        downloadFile({
                            data: (resp.data),
                            fileName: name,
                            fileType: `application/${fileType}`,
                        });
                    }
                })
                .catch(error => {
                    if (error?.status == 401 || error?.response?.status == 401) {
                        Logout();
                    }
                    else {
                        setToastMessage(GenericDownloadEmptyToast);
                        setToastError(true);
                        setTimeout(() => {
                            setToastError(false);
                        }, 2000);
                    }
                });
        };

    useEffect(() => {
        localStorage.getItem("navigation_link") ? localStorage.removeItem("navigation_link") : localStorage.setItem("navigation_link", "/synnex-cloud/integrations");
        GetIntegrationListing();
        GetServices();
    }, [])

    useEffect(() => {
        if (integrationContactUsFormFlag) {
            GetIntegrationListing();
            setIntegrationContactUsFormFlag(false);
        }
    }, [integrationContactUsFormFlag])

    return (
        <>
            <Popup
                open={modalOpen}
                onClose={() => { setModalOpen(false); }}
                className="custom-modal custom-modal-md custom-modal-ticket-details"
                modal
                nested
            >
                {(close) => (
                    <div className="modal">
                        <div className="header">
                            <h2>Connectwise Details</h2>
                            <XLg
                                size={24}
                                className="cpointer close-icon-popup"
                                onClick={close}
                            />
                        </div>
                        <Container>
                            <Row>
                                {integrationData && <div dangerouslySetInnerHTML={sanitizeHTML(integrationData[0].additionalDetails)} />}
                            </Row>
                        </Container>
                    </div>
                )}
            </Popup>
            <div className="main-content">
                <Toast toastSetUseState={setToastError} toastCheckUseState={toastError} toastType="danger" toastIconColor={TOAST_ERROR_ICON_COLOR} toastMessage={toastMessage} />

                {!isDisabled && <Container fluid>
                    <h1>Integrations</h1>
                    {
                        integrationData && integrationData.map((item) => {
                            return (
                                <Row className={`mt-4 p-2 ${styles["card"]}`}>
                                    <Col md={2} lg={2} className={`${styles["image-mobile"]}`}>
                                        <img className={`${styles['logo']} p-2`} src={item.integrationLogo} alt="" />
                                    </Col>
                                    <Col md={7} lg={8} className={`py-2 ${styles['connectwise-content-ipad-pro']}`}>
                                        <span className="d-flex align-items-center">
                                            <span className={`text-regular text-strong ${styles["heading-mobile"]}`}>{item.integrationName}</span>
                                            {item.integrationCode === "connectwise" && !item.isIntegrated && (item.ticketStatus === null || item.ticketStatus === "INACTIVE") && <Button className={`${styles['tags-not-integrated-featured']}`}>Not Integrated</Button>}
                                            {item.integrationCode === "connectwise" && item.isIntegrated && <Button className={`${styles['tags-integrated-featured']}`}>Integrated</Button>}
                                            {item.integrationCode === "connectwise" && (item.ticketStatus === "COMPLETED" || item.ticketStatus === "INPROGRESS") && !item.isIntegrated && <Button className={`${styles['tags-request-in-progress']}`}>Integration Request In Progress</Button>}
                                        </span>
                                        <div className="mt-1" dangerouslySetInnerHTML={sanitizeHTML(item.description)} />
                                        {item.integrationCode === "connectwise" && <a className={`${styles['view-more']} text-small cpointer mt-1`} onClick={() => { setModalOpen(true); }}>View more</a>}
                                        {item.integrationCode != "connectwise" && <a className={`${styles['view-more']} text-small cpointer mt-1`}></a>}
                                        {item.integrationCode === "connectwise" && item.ticketStatus === "INPROGRESS" && <span className="text-small">Your request to enable {item.integrationName} has been shared on {item.createdDate} . Please wait until synnex team approves the request.</span>}
                                        {item.integrationCode === "xero" && <span className="text-small text-strong">Latest Invoice Date : {item.latestInvoiceDate} </span>}

                                    </Col>
                                    {item.integrationCode === "connectwise" &&
                                        <Col lg={2} md={3} xs={12} className={`${styles['action-button']}`}>
                                            {!isreadOnly && <Button
                                                type="button"
                                                className={`px-4 btn-border-light w-md-auto col-xs-12 my-2 col-md-8 ${styles['integration-btn-width']}`}
                                                variant="light"
                                                onClick={(e) => { if (item.integrationCode === "connectwise") { DownloadAction(DOWNLOAD_CONNECTWISE_USER_GUIDE, `${item.integrationName}_User_Guide.pdf`, "pdf", item.integrationCode) } }}
                                            >User Guide
                                            </Button>}
                                            {!item.isIntegrated && (item.ticketStatus === null || item.ticketStatus === "INACTIVE") && <Button
                                                type="button"
                                                className={isreadOnly ? "d-none" : `px-4 mx-2 my-2 col-md-8 ${styles['integration-btn-width']}`}
                                                onClick={() => {
                                                    toggleDrawer(true)();
                                                    setSelectService(defaultServiceName);
                                                    setSelectCategory(defaultCategoryName);
                                                    setComingFromIntegration(true);
                                                }}
                                            >Enable
                                            </Button>}
                                            {!item.isIntegrated && item.ticketStatus === "INPROGRESS" && <Button
                                                type="button"
                                                variant="light"
                                                className={isreadOnly ? "d-none" : `px-4 mx-2 my-2 col-md-8 ${styles['integration-btn-width']}`}
                                                disabled
                                            >Enable
                                            </Button>}
                                            {!item.isSyncronizationSetting && item.ticketStatus === "COMPLETED" && <Button
                                                type="button"
                                                onClick={() => {
                                                    navigate("/integrations/configure", {
                                                        state: { integrationId: item.integrationId }
                                                    })
                                                }}
                                                className={isreadOnly ? "d-none" : `px-4 mx-2 my-2 col-md-8 ${styles['integration-btn-width']}`}
                                            >Configure
                                            </Button>}
                                            {item.isIntegrated && item.isSyncronizationSetting && item.isConfigured && <Button
                                                type="button"
                                                className={`px-4 mx-2 my-2 col-md-8 ${styles['integration-btn-width']}`}
                                                onClick={() => {
                                                    navigate("/integrations/manage", {
                                                        state: { integrationId: item.integrationId }
                                                    })
                                                }}
                                            >Manage
                                            </Button>}
                                            {item.isIntegrated && item.isSyncronizationSetting && !item.isConfigured && <Button
                                                variant="light"
                                                className={`px-4 mx-2 my-2 col-md-8 ${styles['integration-btn-width']}`}
                                                disabled
                                            >Manage
                                            </Button>}
                                        </Col>}
                                    {item.integrationCode === "autotask" &&
                                        <Col md={3} lg={2} className={`${styles['action-button']}`}>
                                            <Button
                                                type="button"
                                                variant="light"
                                                className={isreadOnly ? "d-none" : "px-4 mx-2 my-2 col-md-8"}
                                                disabled
                                            >Coming Soon
                                            </Button>
                                        </Col>}
                                        {item.integrationCode === "xero" &&
                                        <Col md={3} lg={2} className={`${styles['action-button']}`}>
                                            <Dropdown>
                                                <Dropdown.Toggle
                                                    variant="primary"
                                                    id="dropdown-download"
                                                    className={`align-items-center px-4 mx-2 my-2 ${styles['integration-btn-width']}`}
                                                >
                                                    Download
                                                </Dropdown.Toggle>

                                                <Dropdown.Menu>
                                                    <Dropdown.Item
                                                        onClick={() => {
                                                            serviceData.map((service)=>{
                                                                if(service.name==="Microsoft CSP"){
                                                                   DownloadReport(XERO_DOWNLOAD_REPORT, `synnex_xero_csp_report.csv`, "csv", "csv",service.integrationCode);
                                                                   DownloadReport(XERO_DOWNLOAD_REPORT, `synnex_xero_csp_report.xlsx`, "xlsx", "excel",service.integrationCode); 
                                                                }
                                                                
                                                            })
                                                        }
                                                        }
                                                    >
                                                        Microsoft CSP
                                                    </Dropdown.Item>
                                                    <Dropdown.Item
                                                        onClick={() => {
                                                            serviceData.map((service)=>{
                                                                if(service.name.includes("Azure")){
                                                                   DownloadReport(XERO_DOWNLOAD_REPORT, `synnex_xero_azure_report.csv`, "csv", "csv",service.integrationCode);
                                                                   DownloadReport(XERO_DOWNLOAD_REPORT, `synnex_xero_azure_report.xlsx`, "xlsx", "excel",service.integrationCode); 
                                                                }
                                                                
                                                            })
                                                        }
                                                        }
                                                    >
                                                        Microsoft Azure
                                                    </Dropdown.Item>
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </Col>}
                                </Row>
                            );
                        })
                    }
                </Container>}
                {
                    isDisabled &&
                    <AccessDenied />
                }
            </div>
        </>
    );
}
export default Integrations;